// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pansage: PokeData = {
  "id": 511,
  "name": "pansage",
  "height": 6,
  "weight": 105,
  "base_experience": 63,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "scratch",
    "vine-whip",
    "leer",
    "bite",
    "leech-seed",
    "lick",
    "fury-swipes",
    "crunch",
    "torment",
    "recycle",
    "natural-gift",
    "fling",
    "seed-bomb",
    "grass-knot",
    "acrobatics",
    "play-nice"
  ],
  "moves": [
    "scratch",
    "vine-whip",
    "leer",
    "bite",
    "lick",
    "crunch",
    "acrobatics",
    "frenzy-plant",
    "wood-hammer",
    "solar-beam",
    "overgrowth",
    "aromatherapy",
    "energy-ball"
  ],
  "evolution_chain": {
    "id": 262,
    "item": null,
    "species": [
      {
        "name": "pansage",
        "order": 512,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "simisage",
        "order": 513,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 511,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "leaf-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 49,
    "speed": 64,
    "ability_power": 53
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
